package no.vareflow.app.domain

/** Closed-session snapshot lines and history records. */

data class CountLineSnapshot(
    val productId: String,
    val productName: String,
    val unit: String,
    val pricePerUnit: Double,
    val vat: Double = 0.0,
    val quantity: Double,
    val departmentName: String = "Bar",
    val note: String = ""
)

data class CountSession(
    val id: String = randomId(),
    val inventorySessionId: String? = null,
    val companyId: String = DomainDefaults.DEMO_COMPANY_ID,
    val locationId: String = DomainDefaults.DEMO_LOCATION_ID,
    val locationName: String = DomainDefaults.DEMO_LOCATION_NAME,
    val yearMonth: String = currentYearMonth(),
    val userId: String,
    val userName: String,
    val createdAt: Long = nowMillis(),
    val lines: List<CountLineSnapshot>,
    val syncState: CloudSaveState = CloudSaveState.LOCAL_SAVED,
    val serverAckAt: Long? = null,
    val syncError: String? = null
)
